import React, { useState } from 'react'
import { InputBoxWraper } from '../../constents/components';
import emailIcon from '../../Assets/svgs/emailIcon.svg';

const Email = ({ email, setEmail, setEmailValid }) => {

    const [isEmailCorrect, setIsEmailCorrect] = useState(false);
    return (
            <InputBoxWraper icon={emailIcon} iconAltText='emailIconText'>
            <input
                className='outline-none w-full bg-transparent'
                type='text'
                placeholder='Email'
                value={email}
                onChange={(e) => {
                    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                    const value = e.target.value;
                    const isValid = emailRegex.test(value);
                    setEmail(value);
                    setIsEmailCorrect(isValid);
                    if (setEmailValid) {
                        setEmailValid(isValid);
                    }
                }}
            />
            </InputBoxWraper>
    )
}
export default Email;


            {/* <div className=' flex gap-2 items-end'>
                
                {!isEmailCorrect && email.length > 0 && (<p className=' text-sm text-red-700 font-semibold'>Please enter a valid email address </p>)}
            </div> */}